/**
 * @generated SignedSource<<14a067abbe98f79df0126438b27ba7f0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type TransportType = "BUS" | "PLANE" | "SHIP";
import { FragmentRefs } from "relay-runtime";
export type PackageDateRowFlightDetails_package$data = {
  readonly transportType: TransportType | null;
  readonly " $fragmentSpreads": FragmentRefs<"PackageDateAddFlightDialog_package">;
  readonly " $fragmentType": "PackageDateRowFlightDetails_package";
};
export type PackageDateRowFlightDetails_package$key = {
  readonly " $data"?: PackageDateRowFlightDetails_package$data;
  readonly " $fragmentSpreads": FragmentRefs<"PackageDateRowFlightDetails_package">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PackageDateRowFlightDetails_package",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "transportType",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PackageDateAddFlightDialog_package"
    }
  ],
  "type": "Package",
  "abstractKey": null
};

(node as any).hash = "893bb83fee4642188a1e73616d4e0182";

export default node;
